import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const HistoryRow = (props) => {
  const { primaryCurrency, secondaryCurrency, amount, rate, post } =
    props;

  return (
    <tr>
      <td>{`Buy ${secondaryCurrency} with ${primaryCurrency}`}</td>
      {/* <td>{account}</td> */}
      <td className="text-danger">{`${amount.toFixed(2)} ${secondaryCurrency}`}</td>
      <td>{`${parseFloat((amount * rate).toFixed(2))} ${primaryCurrency}`}</td>
      <td>{`${parseFloat(rate.toFixed(2))} ${primaryCurrency}/${secondaryCurrency}`}</td>
      <td>{post.created_date.substring(0, 10)}  {post.created_date.substring(11, 19)}</td>
    </tr>
  );
};

export default HistoryRow;
